import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect } from 'react'

const Alert = ({isOpen,onClose,Message}: any) =>{
useEffect(()=>{

  document.documentElement.style.overflow="auto"
},[isOpen])
    return(
        <>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-[9999999]" onClose={onClose}>
            <div className="fixed inset-0 bg-black/50 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md rounded  transform overflow-hidden  bg-white   p-10 text-left align-middle shadow-xl transition-all">
               <Dialog.Title

                      className={`text-lg  ${Message.code===200?"text-green-600":"text-red-600"} text-center`}
                    >
                     {Message.message}
                    </Dialog.Title>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </>
    )
}

export default Alert;